import { App, Button } from 'antd'
import {NavLink, Route, useLocation} from 'react-router-dom'
import { useHasPermission, useMainStates } from './components/state'
import { Permission } from './components/permissions'
import useLocalStorage from './components/useLocalStorage'
import './Menu.css'
import {authService} from "./components/api";
import {UserScope} from "./api/ga/bo/user_scope/user_scope_pb";

export default function Menu() {
  const [, setSessionToken] = useLocalStorage('sessionToken')
  const { userScope, setUserScope} = useMainStates((state) => state)
  const location = useLocation()
  const { modal } = App.useApp()

  const canReadConfigs = useHasPermission(Permission.DevToolsCasinoConfigurationRead)
  const canReadKeys = useHasPermission(Permission.DevToolsCasinoAPIKeyRead)

  const localLogout = () => {
    setUserScope({} as UserScope)
    setSessionToken('')
  }

  return (
    <>
    <div className="Panel">
      <div className="NavLinks">
        {/*<NavLink className="NavLinkView" to={`/${location.search}`}>*/}
        {/*  Main*/}
        {/*</NavLink>*/}

        {canReadConfigs && (
          <NavLink className="NavLinkView" to={`/casino_model${location.search}`}>
            Casino Model
          </NavLink>
        )}

        {canReadConfigs && (
          <NavLink className="NavLinkView" to={`/casino_setting${location.search}`}>
            Casino Settings
          </NavLink>
        )}

        {canReadKeys && (
          <NavLink className="NavLinkView" to={`/casino_keys${location.search}`}>
            Casino Keys
          </NavLink>
        )}

        {canReadConfigs && (
          <NavLink className="NavLinkView" to={`/provider_model${location.search}`}>
            Provider Model
          </NavLink>
        )}

        {canReadConfigs && (
          <NavLink className="NavLinkView" to={`/provider_setting${location.search}`}>
            Provider Settings
          </NavLink>
        )}

        <NavLink className="NavLinkView" to={`/service_config_deployment${location.search}`}>
          Service Config Deployment
        </NavLink>
      </div>

      <div className="LeftSpace">
        <span>{String(userScope?.email ?? '')}</span>

        <Button
          type="primary"
          onClick={() => {
            authService.externalLogout({})
              .then(() => {
                localLogout()
              })
              .catch(() => {
                // Server logout failed: ask the user whether to force a local logout anyway
                modal.confirm({
                  title: 'Logout failed',
                  content: 'Failed to log out on the server. Do you want to log out locally anyway?',
                  okText: 'Log out',
                  cancelText: 'Cancel',
                  okButtonProps: { danger: true },
                  onOk: () => {
                    localLogout()
                  },
                })
              })
          }}
        >
          Logout
        </Button>
      </div>
    </div>
    <div className="PanelSpacer" />
    </>
  )
}
